export default "__VITE_ASSET__Q1c0NW12__"